module.exports = __webpack_public_path__ + "img/sketch_digital.4d1ffa19.jpg";